export default "__VITE_ASSET__CXOHBRCr__"